module.exports = __webpack_public_path__ + "img/1.11.A.decee2b3.png";